import { all } from "redux-saga/effects";
import { getMailingListsWatcher, getMailingListWatcher } from "./getMailingList.saga";
import { getSubsidiariesWatcher } from "./getSubsidiaries.saga";
import { getMailingListTypestWatcher } from "./getMailingListTypes.saga";
import { addMailingListWatcher, toggleMailingListActiveStateWatcher, editMailingListWatcher } from "./saveMailingList.saga";

export default function* rootSaga() {
    yield all([
        getMailingListsWatcher(),
        getMailingListWatcher(),
        getSubsidiariesWatcher(),
        getMailingListTypestWatcher(),
        addMailingListWatcher(),
        editMailingListWatcher(),
        toggleMailingListActiveStateWatcher()
    ]);
}
